<div *ngIf = "!isHandset ; else mobileTemplate">
  <h4 class="text-center">{{ topText }}</h4>
  <div class="row no-gutters plansHolder">
      <div class="col-3 plan" [ngClass]="{'currentPlan': !signupMode && !subUserAcct?.subscribed}">
          <img src="../assets/PRICINGTABLE_FREE.png" height="300" (click)="signupMode ? openPaymentFormEvent.emit(freePlan) : subscriptionCancelEvent.emit()">
          <!-- <h5>PLAN 1</h5>
        {{ this.allSubscriptionPlans[0].name }}<br>
        ${{ this.allSubscriptionPlans[0].price }}  {{ this.allSubscriptionPlans[0].cadenceDisp.key }} -->
      </div>
      <div class="col-3 plan" *ngFor="let aPlan of allSubscriptionPlans.slice(0,3)"
          [ngClass]="{'currentPlan': subUserAcct?.subscribed && subUserAcct?.subscriptionRecord?.subscriptionPrice.uid === aPlan.uid, 'grayed': aPlan.name === 'Student' && !subUserAcct?.email.includes('.edu')}">
          <img [src]="aPlan.accompanyingFilePath" (click)="openPaymentFormEvent.emit(aPlan)">
      </div>
      <!-- <div class="col-3 plan" [ngClass]="{'currentPlan': subUserAcct.subscribed && subUserAcct.subscriptionRecord?.subscriptionPrice.uid == getPlanByName('Monthly').uid}">
        <img src="../assets/PRICINGTABLE_MONTHLY.png" (click)="openPaymentForm(subUserAcct, this.allSubscriptionPlans[0])">
      </div>
      <div class="col-3 plan" [ngClass]="{'currentPlan': subUserAcct.subscribed && subUserAcct.subscriptionRecord?.subscriptionPrice.uid == getPlanByName('Annual').uid}">
        <img src="../assets/PRICINGTABLE_ANNUAL.png" (click)="openPaymentForm(subUserAcct, this.allSubscriptionPlans[1])">
      </div>
      <div class="col-3 plan" [ngClass]="{'currentPlan': subUserAcct.subscribed && subUserAcct.subscriptionRecord?.subscriptionPrice.uid == getPlanByName('Student').uid, 'grayed': !subUserAcct.email.includes('.edu')}">
        <img src="../assets/PRICINGTABLE_STUDENT.png" (click)="openPaymentForm(subUserAcct, this.allSubscriptionPlans[2])">
      </div> --> 
  </div>
  <div>
    <h6 class="text-center">*Prices are displayed in USD.</h6>
  </div>
  <div *ngIf="devOrTestingMode">
      <!-- daily plan for testing -->
      <h5>SECRET PLAN 4</h5>
      {{ allSubscriptionPlans[3].name }}<br>
      ${{ allSubscriptionPlans[3].price }} {{ allSubscriptionPlans[3].cadenceDisp.key }}
      <button class="btn btn-outline-primary" type="button"
          (click)="openPaymentFormEvent.emit(allSubscriptionPlans[3])">Choose</button>
  </div>
</div>

<ng-template #mobileTemplate>
  <div>
    <h4 class="text-center">{{ topText }}</h4>
    <div class="row no-gutters plansHolder" style = "display: grid; justify-content: center;">
      <div class="col-3 plan" [ngClass]="{'currentPlan': !signupMode && !subUserAcct?.subscribed}">
          <img src="../assets/PRICINGTABLE_FREE.png" height="300" (click)="signupMode ? openPaymentFormEvent.emit(freePlan) : subscriptionCancelEvent.emit()">
          <!-- <h5>PLAN 1</h5>
        {{ this.allSubscriptionPlans[0].name }}<br>
        ${{ this.allSubscriptionPlans[0].price }}  {{ this.allSubscriptionPlans[0].cadenceDisp.key }} -->
      </div>
      <div class="col-3 plan" *ngFor="let aPlan of allSubscriptionPlans.slice(0,3)"
          [ngClass]="{'currentPlan': subUserAcct?.subscribed && subUserAcct?.subscriptionRecord?.subscriptionPrice.uid === aPlan.uid, 'grayedMobile': aPlan.name === 'Student' && !subUserAcct?.email.includes('.edu')}">
          <img [src]="aPlan.accompanyingFilePath" (click)="openPaymentFormEvent.emit(aPlan)">
      </div>
    </div>

        <!-- <div class="col-3 plan" [ngClass]="{'currentPlan': subUserAcct.subscribed && subUserAcct.subscriptionRecord?.subscriptionPrice.uid == getPlanByName('Monthly').uid}">
          <img src="../assets/PRICINGTABLE_MONTHLY.png" (click)="openPaymentForm(subUserAcct, this.allSubscriptionPlans[0])">
        </div>
        <div class="col-3 plan" [ngClass]="{'currentPlan': subUserAcct.subscribed && subUserAcct.subscriptionRecord?.subscriptionPrice.uid == getPlanByName('Annual').uid}">
          <img src="../assets/PRICINGTABLE_ANNUAL.png" (click)="openPaymentForm(subUserAcct, this.allSubscriptionPlans[1])">
        </div>
        <div class="col-3 plan" [ngClass]="{'currentPlan': subUserAcct.subscribed && subUserAcct.subscriptionRecord?.subscriptionPrice.uid == getPlanByName('Student').uid, 'grayed': !subUserAcct.email.includes('.edu')}">
          <img src="../assets/PRICINGTABLE_STUDENT.png" (click)="openPaymentForm(subUserAcct, this.allSubscriptionPlans[2])">
        </div> --> 
    <div>
      <h6 class="text-center">*Prices are displayed in USD.</h6>
    </div>
    <br>
    <br>
    <div *ngIf="devOrTestingMode">
        <!-- daily plan for testing -->
        <h5>SECRET PLAN 4</h5>
        {{ allSubscriptionPlans[3].name }}<br>
        ${{ allSubscriptionPlans[3].price }} {{ allSubscriptionPlans[3].cadenceDisp.key }}
        <button class="btn btn-outline-primary" type="button"
            (click)="openPaymentFormEvent.emit(allSubscriptionPlans[3])">Choose</button>
    </div>
  </div>
</ng-template>
